import React, {Component} from 'react';
import CommesseSelectTableRow from './CommesseSelectTableRow'
import TablePager from '../TablePager'
import TableColumnOrdered from '../TableColumnOrdered'
import PropTypes from 'prop-types';
class CommesseTable extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };

        this.pages = [];
        this.firstPage = 1;
        this.page = this.props.page;

        this.onChangePage = this.onChangePage.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.lastPage = Math.ceil(nextProps.count / nextProps.rowperpage);
        this.page = nextProps.page;
        this.pages = [];
        for (let i = 1; i <= this.lastPage; i++) {
            this.pages.push(i);
        }
        this.forceUpdate()
    }

    onChangePage(newpage) {
        switch (newpage)
        {
            case "P":
                if (this.props.page > this.firstPage){
                    this.props.onChangePage(this.props.page - 1);
                }
                break;
            case "N":
                if (this.props.page < this.lastPage){
                    this.props.onChangePage(this.props.page + 1);
                }
                break;
            default:
                if (this.page !== newpage){
                    this.props.onChangePage(newpage);
                }
                break;
        }
    }

    render() {
        return (<table className="ui sortable small compact  table">
            <thead>
            <tr>
                <TableColumnOrdered
                    tableOrderingField={this.props.tableOrderingField}
                    columnOrderingField="nome"
                    onChangeOrder={this.props.onChangeOrder}
                >Nome</TableColumnOrdered>
            </tr>
            </thead>
            <tbody>
            {this.props.items.map((commessa) => (
                <CommesseSelectTableRow
                    commessa={commessa}
                    key={commessa.idCommessa}
                    onCommessaSelect={this.props.onCommessaSelect}
                />
            ))}
            </tbody>
            <tfoot>
            <tr><th className="small">
                <TablePager
                    values="2"
                    pages={this.pages} page={this.page}
                    firstPage={this.firstPage} lastPage={this.lastPage}
                    onChangePage={this.onChangePage}
                />
            </th>
            </tr></tfoot>
        </table>)
    }
}

CommesseTable.PropTypes = {
    items: PropTypes.array,
    count: PropTypes.number,
    page: PropTypes.number,
    rowperpage: PropTypes.number,
    tableOrderingField: PropTypes.string,
    tableOrderingDirection: PropTypes.oneOf(['A', 'D']),
    onChangePage: PropTypes.func,
    onChangeOrder: PropTypes.func,
    onCommessaSelect: PropTypes.func.isRequired
}
export default CommesseTable;




/** WEBPACK FOOTER **
 ** ./src/components/commesse/CommesseSelectTable.js
 **/